// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2D_4N","range":"MonthRangeSwitch_range__OcXUe","disabled":"MonthRangeSwitch_disabled__2YRS1"};